export const CODE_LOAI_PHIEU ={
  THU_TIEN: {
    code: "TT",
    name: "Thu tiền"
  },
  HOAN_TIEN: {
    code: "HT",
    name: "Hoàn tiền"
  },
  TAM_UNG: {
    code: "TU",
    name: "Tạm ứng"
  },
  HOAN_UNG: {
    code: "HU",
    name: "Hoàn ứng"
  },
  THU_TIEN_0_DONG: {
    code: "TT0D",
    name: "Thu tiền 0 đồng"
  },
}

export const CODE_HINH_THUC = {
  TIEN_MAT: "TM",
  CHUYEN_KHOAN: "CK",
  TAT_TOAN: "TT"
}


export const MOC_THOI_GIAN = {
  NGAY: "ngay",
  THANG: "thang",
  QUY: "quy",
  NAM: "nam",
  KHAC: "khac",
}